import React from "react";
import { Icon } from "@mdi/react";
import { mdiAlert, mdiCheckCircle, mdiInformation, mdiCloseCircle } from "@mdi/js";
import Button from "../Button";
import Modal from "./index";

interface GenericModalProps {
  isOpen: boolean;
  closeModal: () => void;
  title: string;
  message: string;
  type: "warning" | "success" | "info" | "danger";
  onConfirm?: () => void;
  confirmText?: string;
  onClose?: () => void;
  closeText?: string;
}

const iconMap = {
  warning: { icon: mdiAlert, color: "text-orange-600" },
  success: { icon: mdiCheckCircle, color: "text-success" },
  info: { icon: mdiInformation, color: "text-info" },
  danger: { icon: mdiCloseCircle, color: "text-error" }
};

const GenericModal: React.FC<GenericModalProps> = ({
  isOpen,
  closeModal,
  title,
  message,
  type,
  onConfirm,
  confirmText = "Confirm",
  onClose,
  closeText = "Close"
}) => {
  const { icon, color } = iconMap[type];

  return (
    <Modal
      isOpen={isOpen}
      closeModal={closeModal}
      wrapperClass="!my-auto desktop:!min-h-fit text-sm"
      dialogClass="!bg-foreground !p-4 !border !border-card !overflow-y-auto gap-4"
      closeClass="!top-24 !right-6 !bg-transparent !text-placeholder">
      <div className={`flex items-center gap-2 text-xl font-bold ${color}`}>
        <Icon path={icon} size={1.5} />
        <span>{title}</span>
      </div>
      <p className="flex flex-col gap-3 px-12 mb-1.5">{message}</p>
      <div className="flex justify-end gap-2 px-4 mt-6">
        {onClose && (
          <Button
            type="button"
            rounded
            variant="outline"
            onClick={onClose}
            className="self-end w-30 h-9">
            {closeText}
          </Button>
        )}
        {onConfirm && (
          <Button
            type="button"
            onClick={onConfirm}
            className="self-end text-white bg-orange-500 rounded-full w-30 h-9 hover:bg-orange-600">
            {confirmText}
          </Button>
        )}
      </div>
    </Modal>
  );
};

export default GenericModal;
